import Quill from 'quill';

const ColorPicker = Quill.import('ui/color-picker');

class MtColorPicker extends ColorPicker {
  constructor(select, icons) {
    super(select, icons);
    this.container.classList.add('ql-bar');
  }
}

export default MtColorPicker;
